var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.428 8.47 17.302 3.78c-.52-1.04-1.823-1.04-2.604.001l-3.126 4.69c-.52 1.042 0 2.344 1.302 2.344h6.252c1.302 0 1.823-1.302 1.302-2.344zM3.238 29.828h25.525c1.823 0 2.865-1.823 1.823-3.386l-7.293-11.46c-.52-.782-1.302-1.303-2.344-1.303H11.05c-1.04 0-1.822.52-2.343 1.301L1.414 26.444c-1.042 1.563 0 3.386 1.823 3.386z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFei);
export default __webpack_public_path__ + "static/media/FEI.ddf310c6b35d615b5c16a13547cfe7f1.svg";
export { ForwardRef as ReactComponent };